module.exports = __webpack_public_path__ + "static/media/sun-light-spring-equinox.4746f722.svg";